import React from 'react';

const AccountFormContext = React.createContext({});

export default AccountFormContext;
